import { type Theme, Variant } from "@/types/theme";
import React from "react";

export const themes = {
  dark: [Variant.Green, Variant.Orange, Variant.Blue, Variant.Pink],
  light: [Variant.DarkGreen, Variant.DarkBlue, Variant.Bordeaux],
};

export const ThemeContext = React.createContext({
  theme: "dark" as Theme,
  currentTheme: "dark" as "dark" | "light",
  variant: Variant.Green,
  setTheme: (theme: Theme) => {},
  setVariant: (variant: Variant) => {},
});
